<template>
  <BaseModal
    :title="(loading || !lounge?.name) ? '...' : lounge.name"
    ref="modal"
    height="tall"
    startOpen
  >
    <template v-if="errored">
      <p class="error-message">Failed to load lounge details. Please try again.</p>
    </template>
    <template v-else>
      <h5><i class="fa-regular fa-location-dot"></i>  {{ lounge.location }}</h5>
      <p v-html="lounge.description"></p>
    </template>

    <template #footer>
      <div class="button-group">
        <button v-if="loading" class="button button--loading" />
        <button v-else type="button" @click="modalClose" class="button button--primary">
          Close
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import axios from 'axios';
import { store } from '~/Frontend/store';

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      lounge: {},
      loading: true,
      errored: false,
    };
  },
  mounted() {
    this.fetchLoungeDetails();
  },
  methods: {
    fetchLoungeDetails() {
      this.loading = true;
      this.errored = false;
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      };
      axios.get(this.endpoint, config)
        .then((response) => {
          this.lounge = response.data.data;
        }).then(() => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
          this.errored = true;
        });
    },
    modalClose() {
      this.$refs.modal.close();
    },
  },
  computed: {
    eventEdition() {
      return store.eventEdition;
    },
    endpoint() {
      if (window.location.pathname.includes('/iframe/eventmap/')) {
        return `/${this.eventEdition.slug}/iframe/eventmap/meeting-lounges/${this.id}`;
      }
      return `/${this.eventEdition.slug}/meeting-lounges/${this.id}`;
    },
  },
};
</script>
